import React from 'react';
import { makeStyles } from '@material-ui/core';
import Loader from '../../assets/images/Loader.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles((theme) => ({
	loaderCont: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: '#F8F8F8AD',
	},
	loader: {
		left: '41%',
		top: '45%',
		zIndex: 1000,
		position: 'absolute',
	},
}));

const PaymentLoader = () => {
	const classes = useStyles();
	// Define the string
	var string = 'Hello World!';

	// Encode the String
	var encodedString = btoa(string);
	console.log(encodedString); // Outputs: "SGVsbG8gV29ybGQh"

	// Decode the String
	var decodedString = atob(encodedString);
	console.log(decodedString); // Outputs: "Hello World!"
	return (
		<div className={classes.loaderCont}>
			<div className={classes.loader}>
				{/* <CircularProgress color='secondary' /> */}
				<img
					style={{ height: 150 }}
					src={
						'https://i.gifer.com/origin/b4/b4d657e7ef262b88eb5f7ac021edda87.gif'
					}
				/>
			</div>
		</div>
	);
};

export default PaymentLoader;
